import Breadcrumbs, {BreadcrumbsProps} from '@mui/material/Breadcrumbs';

import {styled} from '@mui/material/styles';

export const CBreadcrumbs = styled(Breadcrumbs)<BreadcrumbsProps>(
  (/* { theme } */) => ({
  }),
);
